/*
 * Skarpe betalingsikoner og Trustpilot-stjerner (CRO 02-10-2026).
 * Tekstlinjer over ikonerne giver ofte positioner med decimaler (fx 1703,08 px),
 * og saa bliver kanterne paa ikonerne uskarpe, isaer paa skaerme uden retina.
 * Scriptet flytter ikon-raekkerne de faa decimaler, saa de ligger paa hele pixels.
 */
(function () {
  var SELECTOR = '.payment-trust-row, .cart-drawer-trust';
  var queued = false;

  function snap() {
    queued = false;
    var dpr = window.devicePixelRatio || 1;
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.style.transform = '';
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      var dx = Math.round(r.left * dpr) / dpr - r.left;
      var dy = Math.round(r.top * dpr) / dpr - r.top;
      if (Math.abs(dx) > 0.01 || Math.abs(dy) > 0.01) {
        el.style.transform = 'translate(' + dx.toFixed(3) + 'px,' + dy.toFixed(3) + 'px)';
      }
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(snap);
  }

  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  window.addEventListener('scroll', queue, { passive: true });
  document.addEventListener('cart-drawer:open', function () { setTimeout(queue, 400); });
  document.addEventListener('line-item:change:end', queue);
  // Kurven tegnes forfra efter aendringer, og billeder/skrifttyper kan flytte layoutet
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  queue();
})();
